<script setup lang="ts">
</script>

<template>
  <div>
    <NuxtLayout />
  </div>
</template>

<script setup>
useHead({
  link: [
    {
      rel: "preload",
      href: "/fonts/RotterdamSignature.woff2",
      as: "font",
      type: "font/woff2",
      crossorigin: "anonymous"
    },

    {
      rel: "preload",
      href: "/fonts/Poppins-Regular.woff2",
      as: "font",
      type: "font/woff2",
      crossorigin: "anonymous"
    },
    {
      rel: "preload",
      href: "/fonts/Poppins-SemiBold.woff2",
      as: "font",
      type: "font/woff2",
      crossorigin: "anonymous"
    },
    {
      rel: "preload",
      href: "/fonts/Poppins-Bold.woff2",
      as: "font",
      type: "font/woff2",
      crossorigin: "anonymous"
    },

  ]
})
</script>